import type { RouteLocationRaw } from 'vue-router';

export function toWorkspaceRoute(workspaceSlug: string | null | undefined, routeName: string, routeParams?: Record<string, string>): RouteLocationRaw {
	if (!workspaceSlug) return { name: routeName };

	return {
		name: routeName,
		params: { workspace: workspaceSlug, ...routeParams },
	};
}
